// extracted by mini-css-extract-plugin
export var hideEditor = "_mp-2";
export var infoIcon = "_mp-3";
export var label = "_mp-1";
export var labelContainer = "_mp-0";
export var readonlyText = "_mp-4";